import { render, staticRenderFns } from "./AgentInvitationsHandler.vue?vue&type=template&id=6ecd27af"
import script from "./AgentInvitationsHandler.vue?vue&type=script&lang=js"
export * from "./AgentInvitationsHandler.vue?vue&type=script&lang=js"
import style0 from "./AgentInvitationsHandler.vue?vue&type=style&index=0&id=6ecd27af&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports